import { render, staticRenderFns } from "./CreditorStats.vue?vue&type=template&id=10d1ef41"
import script from "./CreditorStats.vue?vue&type=script&lang=js"
export * from "./CreditorStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports